// CARTO raster basemap tiles (the light gray "Positron" style used by the
// E&U comp map, the packet PDF map, and the Supported CADs map).
//
// CARTO began requiring an API key on its free raster tiles in Sept 2026 --
// without one every tile comes back stamped "API KEY REQUIRED". The key is
// free, domain-restricted, and rate-limited to 5M tiles/month; it is meant to
// ship in the browser bundle, so a literal fallback here is fine. Override it
// at build time with REACT_APP_CARTO_API_KEY if it is ever rotated.
//
// The backend copy lives in backend/reporting/pdf/sections/eu_map.py
// (CARTO_API_KEY). Keep the two in sync.

export const CARTO_API_KEY =
  process.env.REACT_APP_CARTO_API_KEY || "cb1_2vgn_1_e6f1190c3ec78ccac5b1c17f";

export const CARTO_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>';

/**
 * Leaflet tile URL template for a CARTO raster style.
 * @param {"light_all"|"light_nolabels"|"light_only_labels"|"dark_all"|"voyager"} style
 */
export function cartoTileUrl(style = "light_all") {
  return `https://{s}.basemaps.cartocdn.com/${style}/{z}/{x}/{y}{r}.png?key=${CARTO_API_KEY}`;
}
